import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { DeliveryDate, OCC_ENDPOINTS, OccDeliveryDate } from '@delivery/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccDeliveryDateService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadDeliveryDate(cartId: string): Observable<DeliveryDate> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.deliveryDate, {
      urlParams: { cartId },
    });

    return this.http.get<OccDeliveryDate>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.deliveryDate),
    });
  }
}
